/**
 * Scroll to Categories Section
 * Handles smooth scrolling to the popular categories section with highlight effect
 */
(function() {
  'use strict';

  const CATEGORIES_SECTION_ID = 'popular-categories';
  const HIGHLIGHT_CLASS = 'categories-highlight';
  const HIGHLIGHT_DURATION = 2000;

  /**
   * Scroll to categories section with highlight effect
   */
  function scrollToCategories() {
    const section = document.getElementById(CATEGORIES_SECTION_ID);
    if (!section) return false;

    // Get header height for offset
    const header = document.querySelector('.header, [role="banner"]');
    const headerHeight = header ? header.offsetHeight : 0;
    const offset = headerHeight + 20;

    // Calculate scroll position
    const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - offset;

    // Smooth scroll
    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    });

    // Add highlight effect after scroll completes
    setTimeout(function() {
      highlightSection(section);
    }, 500);

    return true;
  }

  /**
   * Add highlight effect to section
   */
  function highlightSection(section) {
    section.classList.add(HIGHLIGHT_CLASS);

    // Remove highlight after animation
    setTimeout(function() {
      section.classList.remove(HIGHLIGHT_CLASS);
    }, HIGHLIGHT_DURATION);
  }

  /**
   * Check if link text matches "categories" (case insensitive)
   */
  function isCategoriesLink(element) {
    const text = element.textContent || element.innerText || '';
    return text.trim().toLowerCase() === 'categories';
  }

  /**
   * Handle categories link click
   */
  function handleCategoriesClick(event) {
    const link = event.target.closest('a');
    if (!link) return;

    // Check if this is a categories link
    if (!isCategoriesLink(link)) return;

    // Check if we're on the home page
    const isHomePage = window.location.pathname === '/' ||
                       window.location.pathname === '/index' ||
                       window.location.pathname.endsWith('/index.html');

    if (isHomePage) {
      // Same page - just scroll
      event.preventDefault();
      scrollToCategories();
    } else {
      // Different page - redirect to home with hash
      event.preventDefault();
      window.location.href = '/#' + CATEGORIES_SECTION_ID;
    }
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    // Handle clicks on navigation links
    document.addEventListener('click', handleCategoriesClick);

    // Check for hash on page load (for cross-page navigation)
    if (window.location.hash === '#' + CATEGORIES_SECTION_ID) {
      // Small delay to ensure page is fully loaded
      setTimeout(function() {
        scrollToCategories();
        // Clean up the URL
        if (history.replaceState) {
          history.replaceState(null, null, window.location.pathname);
        }
      }, 300);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
